const BudgetModuleYearCard = ({ title, isSelected, onClick }) => {
  return (
    <div
      className="year-card"
      onClick={onClick}
      style={{
        borderWidth: 2,
        borderColor: isSelected ? "#0067D5" : undefined,
        background: isSelected ? "#0067D5" : undefined,
        color: isSelected ? "white" : undefined,
        height: isSelected ? "2.5rem" : undefined,
      }}
    >
      <p
        className="year-cardText"
        style={{
          fontSize: isSelected ? "1.5rem" : undefined,
          fontWeight: isSelected ? "bold" : undefined,
        }}
      >
        {title}
      </p>
    </div>
  );
};

export default BudgetModuleYearCard;
